export default __webpack_public_path__ + "static/media/calendarWhiteIcon.3231b097.svg";